/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
'use client'

import classNames from 'classnames'
import { useState } from 'react'
import Popover from '@dustin-web/microsite-components/src/popover'
import {
  getMediaUrl,
  getProductUrl,
  getRelativeProductImageUrl,
} from '@dustin-web/microsite-components/src/utils/urls'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks/use-translations'
import Image from '@dustin-web/microsite-components/src/image'
import dynamic from 'next/dynamic'
import Link from 'next/link'
// @ts-ignore
const ARight = dynamic(() => import('./svg/a-right.svg'))
// @ts-ignore
const ALeft = dynamic(() => import('./svg/a-left.svg'))
// @ts-ignore
const BRight = dynamic(() => import('./svg/b-right.svg'))
// @ts-ignore
const BLeft = dynamic(() => import('./svg/b-left.svg'))
// @ts-ignore
const CRight = dynamic(() => import('./svg/c-right.svg'))
// @ts-ignore
const CLeft = dynamic(() => import('./svg/c-left.svg'))
// @ts-ignore
const DRight = dynamic(() => import('./svg/d-right.svg'))
// @ts-ignore
const DLeft = dynamic(() => import('./svg/d-left.svg'))
// @ts-ignore
const ERight = dynamic(() => import('./svg/e-right.svg'))
// @ts-ignore
const ELeft = dynamic(() => import('./svg/e-left.svg'))
// @ts-ignore
const FRight = dynamic(() => import('./svg/f-right.svg'))
// @ts-ignore
const FLeft = dynamic(() => import('./svg/f-left.svg'))
// @ts-ignore
const GRight = dynamic(() => import('./svg/g-right.svg'))
// @ts-ignore
const GLeft = dynamic(() => import('./svg/g-left.svg'))

type Maybe<T> = T | undefined | null
export type TextAlignment = 'top' | 'right' | 'bottom' | 'left'
type LabelDirection = 'right' | 'left'

type Props = {
  energyClass?: Maybe<string>
  energyDocumentId?: Maybe<string>
  energyLabelImageId?: Maybe<string>
  productId: string
  nameSlug: string
  productTitle: string
  width?: number
  clickFn?: () => void
  labelDirection?: LabelDirection
  textAlignment?: TextAlignment
  togglePopoverOnHover?: boolean
  className?: string
  nextLink?: boolean
  shallow?: boolean
}

export const EnergyLabel = ({
  energyClass,
  energyDocumentId,
  energyLabelImageId,
  productId,
  nameSlug,
  productTitle,
  width = 45,
  clickFn,
  labelDirection = 'right',
  textAlignment = 'bottom',
  togglePopoverOnHover = true,
  className = '',
  nextLink,
  shallow,
}: Props) => {
  const { translate } = useTranslations()
  const [popoverOpen, setPopoverOpen] = useState(false)

  if (!energyClass) {
    return null
  }

  const hideLabel = energyClass.includes('A+')

  const energyDocumentIdUrl = getMediaUrl(energyDocumentId, 'energyDocument')

  const energyLabelImageUrl =
    energyLabelImageId &&
    getRelativeProductImageUrl(energyLabelImageId, 280, 560, `${productTitle}-energylabel`)

  const isOpen = !!energyLabelImageUrl && popoverOpen
  const row = textAlignment === 'right' || textAlignment === 'left'
  const column = textAlignment === 'top' || textAlignment === 'bottom'

  return (
    <Popover
      open={isOpen}
      onToggle={x => setPopoverOpen(x)}
      content={
        <Image
          src={energyLabelImageUrl || ''}
          alt="energy-efficiency"
          height={560}
          width={280}
          className=""
        />
      }
      positions={['bottom-right', 'bottom-left', 'bottom-center']}
      toggleOnHover={togglePopoverOnHover}
      closeBtn={false}
      className={className}>
      <div
        className={classNames('d-flex', {
          'flex-column align-items-start': column,
          'align-items-center': row,
          'align-items-end': labelDirection === 'left',
        })}>
        {/* <span
              className="c-energy-label__label"
              onClick={() => setPopoverOpen(!popoverOpen)}
              role="button"
              tabIndex={0}
              onKeyDown={event => {
                if (event.code === 'Enter') setPopoverOpen(!popoverOpen)
              }}>
              {energyClass}
            </span> */}
        {!hideLabel && (
          <div
            className={classNames({
              'u-mb-8': textAlignment === 'bottom',
              'u-mr-8': textAlignment === 'right',
              'order-2': textAlignment === 'top' || textAlignment === 'left',
            })}>
            <EnergyLabelIcon
              energyClass={energyClass}
              width={width}
              labelDirection={labelDirection}
            />
          </div>
        )}
        <div
          className={classNames('u-line-height-1', {
            'u-mb-8': textAlignment === 'top',
            'u-mr-8': textAlignment === 'left',
          })}>
          {energyDocumentIdUrl ? (
            <a
              target="_blank"
              rel="noreferrer"
              href={energyDocumentIdUrl}
              className="u-fs-12 u-color-mute u-decoration-none"
              dangerouslySetInnerHTML={{
                __html: translate('ProductEnergyDataSheet_HTML'),
              }}></a>
          ) : clickFn ? (
            <button
              type="button"
              className="button-stripped u-mb-0 u-fs-12 u-color-mute u-decoration-none"
              onClick={clickFn}
              dangerouslySetInnerHTML={{
                __html: translate('ProductEnergyDataSheet_HTML'),
              }}></button>
          ) : nextLink ? (
            <Link
              shallow={shallow}
              href={getProductUrl(productId, nameSlug, undefined, true, 'accessories')}
              className="u-fs-12 u-color-mute u-decoration-none"
              dangerouslySetInnerHTML={{
                __html: translate('ProductEnergyDataSheet_HTML'),
              }}
            />
          ) : (
            <a
              href={getProductUrl(productId, nameSlug, undefined, true, 'specification')}
              className="u-fs-12 u-color-mute u-decoration-none"
              dangerouslySetInnerHTML={{
                __html: translate('ProductEnergyDataSheet_HTML'),
              }}></a>
          )}
        </div>
      </div>
    </Popover>
  )
}

const EnergyLabelIcon = ({
  energyClass,
  width,
  labelDirection,
}: {
  energyClass: Maybe<string>
  width: number
  labelDirection: LabelDirection
}) => {
  if (!energyClass) {
    return null
  }

  const right = labelDirection === 'right'
  const left = labelDirection === 'left'

  return (
    <div
      className="c-energy-label-icon d-flex align-items-center"
      style={{ width: width, height: 'auto' }}>
      {energyClass === 'A' && right && <ARight />}
      {energyClass === 'B' && right && <BRight />}
      {energyClass === 'C' && right && <CRight />}
      {energyClass === 'D' && right && <DRight />}
      {energyClass === 'E' && right && <ERight />}
      {energyClass === 'F' && right && <FRight />}
      {energyClass === 'G' && right && <GRight />}
      {energyClass === 'A' && left && <ALeft />}
      {energyClass === 'B' && left && <BLeft />}
      {energyClass === 'C' && left && <CLeft />}
      {energyClass === 'D' && left && <DLeft />}
      {energyClass === 'E' && left && <ELeft />}
      {energyClass === 'F' && left && <FLeft />}
      {energyClass === 'G' && left && <GLeft />}
    </div>
  )
}

export default EnergyLabel
